module.exports = __webpack_public_path__ + "img/pro6-1.bcbac5f4.png";